import { useState } from "react";
import { CloseIcon } from "../../components/icons/Icon2";
import styles from "./Marketing2.module.css";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import Button from "../../components/updatedComponents/Dealers/Button";
import fetchData from "../../APIsControll/apiControll";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import { getStatusColor } from "../../Utils/Utils";

const AssignLeadModal = ({
  mode,
  closeModal,
  managers,
  managerId,
  lead,
  getLeads,
  isSuperAdmin,
  openCloseCompleteLeadModal,
  openShareLeadModal,
}) => {
  const { show } = useToast();
  const [selectedManger, setSelectedManger] = useState({
    label: "Select",
    value: "Select",
  });
  const [loading, setLoading] = useState(false);

  const assignLead = async () => {
    if (isSuperAdmin && selectedManger.value === "Select") {
      show("Please select a manager!", "");
      return;
    }

    const apiData = {
      leadId: lead.leadId,
      managerId: managerId,
      selectedManager: isSuperAdmin ? selectedManger.value : managerId,
    };

    try {
      setLoading(true);
      const res = await fetchData("leads/assignLead", apiData);

      if (res.status === "success") {
        show(res.msg, "success");
        setLoading(false);
        if (!isSuperAdmin) {
          if (lead.type === "wholesale") {
            openCloseCompleteLeadModal(res.lead);
          } else {
            openShareLeadModal(res.lead);
          }
        } else {
          closeModal();
        }
        getLeads();
      }

      if (res.status === "failed") {
        show(res.msg, "error");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <div
      className={styles.assign_lead_modal}
      style={{
        backgroundColor: mode && "#232529",
        height: isSuperAdmin && "460px",
      }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Assign Lead</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div
        className={styles.text_con}
        style={{ borderColor: mode && "#646B88" }}
      >
        <div className={styles.text_con_head}>
          <TextElement
            label={"Name:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.name}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
          <TextElement
            label={"Lead ID:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.leadId}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
        </div>
        <div className={styles.text_con_head}>
          <TextElement
            label={"Mobile:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.mobile}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
          <p
            className={styles.status_text}
            style={{ color: getStatusColor(lead.status) }}
          >
            {lead.status}
          </p>
        </div>
        {lead.type === "wholesale" && (
          <TextElement
            label={"Company:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.storeName}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
        )}
        <TextElement
          label={"Address:"}
          labelColor={mode ? "#fff" : "#646B88"}
          value={
            lead.pincode +
            " " +
            lead.city +
            " " +
            (lead.district || "") +
            " " +
            lead.state
          }
          valueColor={mode ? "#fff" : "#646B88"}
          fontSize={"14px"}
          fontWeight={"600"}
        />
        <TextElement
          label={"Assigned to:"}
          labelColor={mode ? "#fff" : "#646B88"}
          value={
            lead.assignedManager ? lead.assignedManager : "Not assigned yet"
          }
          valueColor={mode ? "#fff" : "#646B88"}
          fontSize={"14px"}
          fontWeight={"600"}
        />
      </div>

      {isSuperAdmin && (
        <div>
          <VerticalDropDown2
            height={"37px"}
            fontSize={"12px"}
            dropDownText={"Select"}
            label={"Assign Manager"}
            value={selectedManger}
            options={managers}
            onchange={(option) => {
              setSelectedManger(option);
            }}
          />
        </div>
      )}

      <div style={{ flex: "1" }} />

      <div className={styles.bottom_buttons}>
        <div style={{ width: "30%" }}>
          <Button
            buttonText={"Close"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#FFFFFF"}
            buttonBorder={"none"}
            buttonClick={closeModal}
          />
        </div>
        <div style={{ width: "30%" }}>
          <Button
            buttonText={isSuperAdmin ? "Assign" : "Accept"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            disabled={
              (isSuperAdmin && selectedManger.label === "Select") || loading
            }
            loading={loading}
            buttonClick={assignLead}
          />
        </div>
      </div>
    </div>
  );
};

export default AssignLeadModal;
